<div class="container">
  <img *ngIf="!pdf.thumbnail" src="assets/img/pdfPlaceholder.png" [style.object-fit]="objectFit">
  <pdf-viewer *ngIf="!pdf.thumbnail"
              [style.opacity]="!pdf.thumbnail ? 0 : 1"
              [src]="pdf.src"
              [original-size]="false"
              [show-all]="true"
              [fit-to-page]="false"
              [zoom]="1"
              [zoom-scale]="'page-width'"
              [stick-to-page]="false"
              [render-text]="true"
              [external-link-target]="'blank'"
              [autoresize]="true"
              [show-borders]="false"
              (page-rendered)="pdfRenderedEvent($event, pdf)"
  ></pdf-viewer>
  <img *ngIf="pdf.thumbnail"
       [src]="pdf.thumbnail"
       [style.object-fit]="objectFit">
</div>

